import { connect } from 'react-redux';
import { fetchRequestCredentialsVerification } from './../../../reducers/consent/consents';
import { resetSubmitFormData } from './../../../reducers/common/submitForm';
import { getTranslation } from "../../../reducers/common/localization";
import CredentialsVerificationRequest from "./CredentialsVerificationRequest";
import {getContinentByCountry, setCurrentContinent} from "../../../reducers/common/location";
import {
    fetchGetAliases,
    fetchGetDefaultAlias, getDefaultAliasName,
    loadingAliases
} from "../../../reducers/account/aliases";
import {
    fetchGetOperationAvailability,
    fetchGetOrg, getEmailDomain, getOperationAvailability, getOrgCountryCode,
    getOrgName, loadingOrg
} from "../../../reducers/organization/organization";
import {getCurrentGroup, getCurrentGroupEmail, getCurrentGroupName} from "../../../reducers/account/role";
import { getUserEmail } from '../../../reducers/account/userData';
import {fetchRequestBulkCredentialsVerification} from "../../../reducers/consent/consents";
import {getSubmitFormSuccessStatus} from "../../../reducers/common/submitForm";

const mapStateToProps = state => {
    return {
        loading: loadingOrg(state) || loadingAliases(state),
        translation: getTranslation(state),
        yourName: getDefaultAliasName(state),
        companyName: getOrgName(state),
        companyDomain: getEmailDomain(state),
        companyCountry: getOrgCountryCode(state),
        companyContinent: getContinentByCountry(getOrgCountryCode(state), state),
        departmentId: getCurrentGroup(state),
        departmentName: getCurrentGroupName(state),
        yourEmail: getUserEmail(state),
        departmentEmail: getCurrentGroupEmail(state),
        success: getSubmitFormSuccessStatus(state),
        operationAvailability: getOperationAvailability(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onMount: () => {
            dispatch(fetchGetDefaultAlias());
            dispatch(fetchGetAliases());
            dispatch(fetchGetOrg());
            dispatch(fetchGetOperationAvailability());
        },
        onProcessRequest: (data) => {
            dispatch(fetchRequestCredentialsVerification(data));
        },
        onProcessBulkRequest: (data) => {
            dispatch(fetchRequestBulkCredentialsVerification(data));
        },
        onContinentsSet: (continentCode) => {
            dispatch(setCurrentContinent(continentCode));
        },
        onResetData: () => {
            dispatch(resetSubmitFormData());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CredentialsVerificationRequest);



// WEBPACK FOOTER //
// ./src/components/consentManagement/credentialsVerificationRequest/CredentialsVerificationRequest.container.js